<nz-tree-select
[nzDropdownStyle]="{ 'max-height': '300px' }"
[(ngModel)]="parentId"
[nzNodes]="nodes"
[nzDisabled]="nzDisabled"
[nzDefaultExpandAll]="nzDefaultExpandAll"
[nzShowSearch]="nzShowSearch"
[nzCheckable]="nzCheckable"
[nzCheckStrictly]="nzCheckStrictly"
[nzPlaceHolder]="nzPlaceHolder"
(ngModelChange)="onChange($event)"
>
</nz-tree-select>
